/**
 * Basic interface defining a session
 */
export interface Session {
  /**
   * The id of the identity that this session is provided with
   */
  identity: string;
}
